export default "__VITE_ASSET__CMaQ261___"